
import { Vue } from 'vue-class-component';
import { PropSync } from 'vue-property-decorator';

export default class Checkbox extends Vue {
	@PropSync('value', { type: Boolean }) valueCheckbox!: boolean;
	@PropSync('color', { type: String }) color!: string;
	@PropSync('disabled', { type: Boolean }) disabled = false;
}
